import $ from 'jquery';
import _ from 'underscore';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Modal from 'root/module/modal';
import Modals from 'root/modals';
import Form from 'root/module/form';
import View from 'view/base';

var Project_Categories = View.extend({
    limit: 20,

    events: {
        'click .category-delete' : 'categoryDelete',
        'click .category-add'    : 'categoryAdd',
        'click .badge-btn'       : 'editCategoryName'
    },

    dom_handlers: {
        categoryDelete: function(e) {
            e.stopPropagation();

            var category = $(e.currentTarget).parent().children('.category-name').text();

            $(e.currentTarget).parent().remove();

            this.categories = _.without(this.categories, category);
            this.$el.find('input[name="categories"]').val(this.categories.join(','));

            if (this.categories.length <= this.limit) {
                this.$el.find('.category-add').removeClass('disabled-btn');
            }
            // getting started page update onboarding
            Cache.app.trackOnboarding('project_categories_edit', '1');
            this.trigger('change');
        },

        categoryAdd: function(e) {
            e.preventDefault();

            if ($(e.currentTarget).hasClass('disabled-btn')) {
                return;
            }

            // some weird circular dependency issue here
            Modals.newFeedbackCategory((category) => {
                if (this.categories.indexOf(category) !== -1) {
                    return;
                }

                _.each(category.split(','), function(category_name) {
                    this.categories.push(category_name.trim());

                    var html = this.getOptionHtml(category_name);
                    var option = $(html).insertBefore(this.$el.find('.category-add'));

                }, this);

                if (this.categories.length > this.limit) {
                    this.$el.find('.category-add').addClass('disabled-btn');
                }

                this.$el.find('input[name="categories"]').val(this.categories.join(','));

                // getting started page update onboarding
                Cache.app.trackOnboarding('project_categories_edit', '1');
                this.trigger('change');
            });
        },

        editCategoryName: function(e) {
            e.preventDefault();

            var content =
            '<form class="form-fluid">' +
                '<button type="submit" class="hidden"></button>' +
                '<div class="row">' +
                    '<div class="field-label">Name</div>' +
                    '<input type="text" name="name" class="solid medium" maxlength="50" autofocus required>' +
                '</div>' +
            '</form>';

            var modal = Modal.open({
                title: 'Edit Category',
                content: content,
                button: {
                    Save: function(e, dialog) {
                        modal.find(':submit').click();
                    }
                }
            });

            var form = modal.find('form');
            var badge = $(e.currentTarget).find('.category-name');

            var old_name = badge.text();

            Form.setData(form, {
                name: old_name
            });

            form.find('input[name="name"]').focus();

            form.on('submit', (e) => {
                e.preventDefault();

                var new_name = Form.getData(form).name;

                badge.text(new_name);

                this.categories = _.without(this.categories, old_name);
                this.categories.push(new_name);

                this.$el.find('input[name="categories"]').val(this.categories.join(','));

                // getting started page update onboarding
                Cache.app.trackOnboarding('project_categories_edit', '1');
                this.trigger('change');

                Modal.close();
            });
        }
    },

    setCategories: function(categories) {
        this.categories = categories;
    },

    initialize: function(options) {
        this.categories = options.categories;
        this.add_new    = !!options.add_new;
        this.edit       = !!options.edit;
    },

    getOptionHtml: function(category) {
        var id = _.uniqueId('category_');

        return '<div class="badge-primary-invert badge-btn margin-right-4 margin-bottom-4 cursor-pointer">' +
                   '<span class="category-name font-weight-medium">' + Util.htmlEntities(category) + '</span>' +
                   '<button type="button" class="category-delete"><i class="far fa-times"></i></button>' +
               '</div>';
    },

    render: function() {
        var content = '';

        _.each(this.categories, function(category) {
            content += this.getOptionHtml(category);
        }, this);

        if (this.add_new) {
            content += '<a href="#" class="primary category-add"><i class="fas fa-plus-circle"></i></a>';
        }

        content += '<input type="hidden" name="categories">';

        this.$el.html(content);

        this.$el.find('input[name="categories"]').val(this.categories.join(','));

        return this;
    }
});

export default Project_Categories;